<template>
  <div id="head">
    <Header v-show="showedMenu" />
  </div>
  <div id="separator"></div>

  <router-view @setPageInfo="setPageInfo" @showMenu="showMenu" @initMaterialize="initMaterialize" />

  <Footer />
</template>

<script>
// components
import Header from '@/components/app/HeaderSection.vue';
import Footer from '@/components/app/FooterSection.vue';

// materialize-css
let M = require('materialize-css');

// use imports
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      showedMenu: true,
    };
  },
  mounted() {
    /*
    M.AutoInit();
    let elems = document.querySelectorAll('.sidenav');
    M.Sidenav.init(elems);
    */
    this.$nextTick(() => {
      this.initMaterialize();
    });
    // re-inicializar cuando cambian las rutas/menus
    this.$watch(
      () => this.menuItems,
      () => {
        this.$nextTick(() => {
          this.initMaterialize();
        });
      },
      { deep: true },
    );
  },
  methods: {
    setPageInfo(title, keywords, description) {
      document.title = title;
      if (document.querySelectorAll('meta[name="keywords"]').length > 0) {
        document.querySelectorAll('meta[name="keywords"]')[0].content = keywords;
      } else {
        let meta = document.createElement('meta');
        meta.name = 'keywords';
        meta.content = keywords;
        document.getElementsByTagName('head')[0].appendChild(meta);
      }
      if (document.querySelectorAll('meta[name="description"]').length > 0) {
        document.querySelectorAll('meta[name="description"]')[0].content = description;
      } else {
        let meta = document.createElement('meta');
        meta.name = 'description';
        meta.content = description;
        document.getElementsByTagName('head')[0].appendChild(meta);
      }
    },
    showMenu(value) {
      this.showedMenu = value;
    },
    initMaterialize() {
      //const M = window.M;
      M.AutoInit();
      if (!M) return;
      // dropdowns (desktop) -> abrir por hover
      const ddElems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(ddElems, {
        constrainWidth: false,
        coverTrigger: false,
        hover: true,
        closeOnClick: false, // no cerrar automáticamente al hacer click dentro (el label es un router-link)
      });
      // sidenav
      const sidenavElems = document.querySelectorAll('.sidenav');
      M.Sidenav.init(sidenavElems);
      // collapsible (mobile submenu)
      const collElems = document.querySelectorAll('.collapsible');
      M.Collapsible.init(collElems);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/custom.scss';
/*
@import "@/assets/styles/fonts.scss";
#head {
  position: fixed;
  width: 100%;
  z-index: 999999;
}
#separator {
  height: 6rem;
}
@media (max-width: 62rem) {
  #head {
    position: relative !important;
  }
  #separator {
    display: none;
  }
}
@media (max-width: 28rem) {
  #separator {
    height: 15rem;
  }
}
@media (max-width: 20rem) {
  #separator {
    height: 18rem;
  }
}
*/
</style>
